import fn from 'shared/lib/modules/fn.js';
import compileTemplate from 'shared/lib/modules/compileTemplate.js';

FINN.travel.lang = FINN.travel.lang || {};

export function add(key, text) {
    if (arguments.length === 1 && typeof key !== 'string') {
        const texts = key;
        fn.keys(texts).forEach(textKey => {
            FINN.travel.lang[textKey] = compileTemplate(texts[textKey]);
        });
    } else {
        FINN.travel.lang[key] = compileTemplate(text);
    }
}

add({
    show_filter: 'Vis filter', // eslint-disable-line camelcase
    hide_filter: 'Skjul filter', // eslint-disable-line camelcase
});
